<div class="header-container">
  <div class="header-title-container">
    <div class="header-logo">
      <img
        loading="lazy"
        src="../../assets/acc_logo.png"
        alt="Logo"
        class="logo-img"
        [routerLink]="['/device-dashboard-page']"
      />
    </div>
    <div class="header-main-title">
      <img
        loading="lazy"
        src="../../assets/header_icon.png"
        alt="Icon"
        class="header-icon"
      />
      <h6>AEPL {{ headerProjectName }} {{ environment }} Diagnostic Cloud</h6>
    </div>
    <nav class="custom-navbar">
      <div
        class="hamburger-menu"
        (click)="toggleMenu()"
        (keydown.enter)="(0)"
        tabindex="0"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
      <ul class="nav-list" [ngClass]="{ 'menu-active': isMenuOpen }">
        <li
          *ngFor="let menu of menuTree"
          class="nav-item dropdown"
          [ngClass]="{ active: activeDropdown === menu.pageName }"
        >
          <ng-container *ngIf="menu.children?.length > 0; else singleLink">
            <a
              href="javascript:;"
              class="dropdown-toggle"
              (click)="toggleDropdown(menu.pageName)"
            >
              {{ menu.pageName | uppercase }}
            </a>
            <ul
              class="dropdown-content"
              [ngClass]="{ show: activeDropdown === menu.pageName }"
            >
              <li
                *ngFor="let child of menu.children"
                [ngClass]="{ 'active-item': activeDropdown === child.pageName }"
              >
                <a
                  (click)="toggleDropdown(null)"
                  [routerLink]="generateRoute(child.pageName)"
                >
                  {{ child.pageName | uppercase }}
                </a>
              </li>
            </ul>
          </ng-container>

          <ng-template #singleLink>
            <a
              (click)="toggleDropdown(null)"
              [routerLink]="generateRoute(menu.pageName)"
            >
              {{ menu.pageName | uppercase }}
            </a>
          </ng-template>
        </li>
        <!-- Profile menu remains same -->
        <li class="nav-item dropdown" [ngClass]="{ active: isProfileActive }">
          <a
            href="javascript:;"
            class="dropdown-toggle"
            (click)="toggleDropdown('profile')"
          >
            Hi,
            {{
              userName
                ? userName.length > 9
                  ? userName.substring(0, 9)
                  : userName
                : '--'
            }}
          </a>
          <ul
            class="dropdown-content"
            [ngClass]="{ show: activeDropdown === 'profile' }"
          >
            <li>
              <a (click)="toggleDropdown(null)" routerLink="profile">Profile</a>
            </li>
            <li><a (click)="logout()" href="#">Log Out</a></li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</div>
